// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    /* ----------------------- */
    --header-height: 5.5rem;
    --border-top: 0.5rem;
    --search-activity-btn-font: normal normal bold 16px/19px Lato;
    --search-activity-btn-letter-spacing: 0.16px;

}

.header-start-section {
    background: var(--neutral-color1) 0% 0% no-repeat padding-box;
    box-shadow: 0rem 0.188rem 0.375rem #00000029;
    height: var(--header-height);
    display: grid;
    border-top: var(--border-top) solid var(--neutral-color7);
    align-items: center;
    z-index: 50;
    opacity: 1;
}

.header-wraper-section {
    display: grid;
    height: 100%;
    align-items: center;
    grid-template-columns: 1fr 6fr;
    width: 100%;
    padding: 0 24px;
    padding-right: 0;
}

.header-wraper-admin-section {
    grid-template-columns: 1fr 4fr;
}

.header-wrapper-admin-super-section {
    grid-template-columns: 1.5fr 6fr;
}

.header-wraper-admin-section .admin-navbar-header-content-section {
    grid-template-columns: 6fr 2fr;
}

.header-wraper-section>.navbar-header-icon-section img {
    cursor: pointer;
    width: 106px;
    height: 53px;
}

.header-wraper-section>.navbar-mobile-menu-group {
    display: none;
}

.navbar-header-content-section {
    height: 100%;
    display: grid;
    align-items: center;
    grid-template-columns: 8fr 2fr;
}

.navbar-header-nav-menu-section {
    display: flex;
    /* grid-template-columns: repeat(4, 1fr) 0.5fr; */
    height: 100%;
    align-items: center;
    justify-content: flex-end;
    text-align: center;
    /* column-gap: 10px; */
}

.navbar-header-nav-menu-section .navbar-header-menu-item .menu-item-text {
    transition: all 0.5s;
}

.navbar-header-nav-menu-section .navbar-header-menu-item:hover .menu-item-text {
    color: var(--call-to-action1);
    transition: all 0.5s;
}

.navbar-header-content-section .navbar-header-nav-menu-section .navbar-header-menu-item:nth-child(5):hover {
    background-color: var(--bg-while-blue);
}

/* point-to */
.super-admin-nav-items {
    grid-template-columns: repeat(3, 3fr) 1.2fr;
}

.admin-super-navbar-header-content-section .navbar-header-nav-menu-section {
    /* grid-template-columns: repeat(4, 3fr) 1.2fr 1.2fr; */
    column-gap: 0;
}

.admin-super-navbar-header-content-section .navbar-header-nav-menu-section .navbar-header-menu-item:last-child.active-tab {
    padding: 0;
}

.navbar-header-nav-menu-section>.navbar-header-menu-item {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    padding: 0 15px;
}

.header-wraper-super-section .navbar-header-nav-menu-section .navbar-header-menu-item:last-child{
    padding: 0;
}

.navbar-header-menu-item>.menu-item-icon {
    margin-right: 10px;
}

.admin-navbar-header-content-section .navbar-header-nav-menu-section .navbar-header-menu-item:nth-child(4) {
    padding: 0;
}

.navbar-header-content-section .navbar-header-nav-menu-section .navbar-header-menu-item:nth-child(5) {
    position: relative;
    padding: 0;
    padding-top: 15px;
    padding-bottom: 15px;
}


.admin-navbar-header-content-section .navbar-header-nav-menu-section .navbar-header-menu-item:nth-child(5) {
    position: relative;
    padding-top: 0;
    padding-bottom: 0;
}


.super-admin-nav-items .navbar-header-menu-item:last-child {
    padding: 0;
    position: relative;
    background: var(--call-to-action1) 0% 0% no-repeat padding-box;
}



.wrapper-navbar-header-menu-item {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 25px;
    padding-right: 25px;
    border-left: 1px solid var(--neutral-color4);
}

.navbar-header-menu-notification {
    min-width: 23px;
    min-height: 23px;
    background: var(--call-to-action1) 0% 0% no-repeat padding-box;
    border-radius: 50%;
    padding: 4px 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--neutral-color1);
    position: absolute;
    top: 10px;
    left: 55%;
}

.switch-user-btn-section {
    height: 100%;
    width: 100%;
    display: grid;
    align-items: center;
    justify-items: center;
    background: var(--call-to-action1) 0% 0% no-repeat padding-box;
    font: normal normal bold 12px/15px Lato;
    letter-spacing: 0.12px;
    padding: 0 10px;
    color: var(--neutral-color1);
    transition: all 0.5s;
}

.switch-user-btn-section svg path {
    fill: var(--neutral-color1);
    transition: all 0.5s;
}

.activetab-switch-user-btn {
    background-color: var(--bg-while-blue);
    transition: all 0.5s;
}

.active-switch-user-btn {
    background-color: var(--indicators-red);
    transition: all 0.5s;
}

.switch-user-btn-icon {
    height: 40%;
}

.activetab-switch-user-btn svg path {
    fill: var(--call-to-action1);
    transition: all 0.5s;
}

.activetab-switch-user-btn .switch-user-btn-text {
    color: var(--call-to-action1);
}

.active-tab .menu-item-text {
    font: normal normal bold 16px/19px Lato;
    letter-spacing: 0.16px;
    color: var(--call-to-action1);
}

.navbar-header-nav-menu-section .active-tab::after {
    content: "";
    height: 4px;
    width: 100%;
    position: absolute;
    background: var(--call-to-action1) 0% 0% no-repeat padding-box;
    bottom: 0;
}

.cart-active {
    background: var(--bg-while-blue) 0% 0% no-repeat padding-box;
}

.cart-active .wrapper-navbar-header-menu-item {
    border: 0;
}

.navbar-header-profile-section {
    height: 100%;
    width: 100%;
    display: grid;
    align-items: center;
    padding: 15px 0;
    cursor: pointer;
}

.wrapper-navbar-header-profile-section {
    height: 100%;
    width: 100%;
    border-left: 1px solid var(--neutral-color4);
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.wrapper-navbar-header-profile-section>.navbar-profile-img,
.navbar-profile-content-section {
    margin-right: 10px;
}

.navbar-profile-img {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: var(--bg-while-blue) 0% 0% no-repeat padding-box;
}

.navbar-profile-content-section>.profile-username {
    font: normal normal bold 12px/15px Lato;
    letter-spacing: 0px;
    color: var(--neutral-color7);
    width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.navbar-profile-content-section>.profile-id {
    font: normal normal bold 14px/17px Lato;
    letter-spacing: 0px;
    color: var(--call-to-action1);
}

/* ------------------- Installer ------------------- */
.navbar-header-search-btn-section {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
}

.wrapper-installer-header-nav-btn {
    position: absolute;
    right: 20px;
    min-width: 170px;
    height: 50px;
    background: var(--call-to-action1) 0% 0% no-repeat padding-box;
    border-radius: 26px;
    padding: 0 12px;
    text-align: center;

    display: flex;
    justify-content: center;
    align-items: center;
    font: var(--search-activity-btn-font);
    letter-spacing: var(--search-activity-btn-letter-spacing);
    color: var(--neutral-color1);
    cursor: pointer;
    transition: all 0.5s;
}

.wrapper-installer-header-nav-btn>svg {
    margin-right: 10px;
}

.wrapper-installer-header-nav-btn:hover {
    background-color: var(--call-to-action2);
    transition: all 0.5s;
}

/* ----------- Profile Section -------- */
.navbar-header-profile-section {
    position: relative;
}

.navbar-header-profile-section.navbar-header-profile-section-active::after {
    content: "";
    height: 4px;
    width: 100%;
    position: absolute;
    background: var(--neutral-color7) 0% 0% no-repeat padding-box;
    bottom: 0;
}

.navbar-header-profile-section {
    background-color: var(--bg-white);
}

.navbar-header-profile-section.navbar-header-profile-section:hover {
    background-color: var(--neutral-color3);
}

.navbar-header-profile-section.navbar-header-profile-section-active {
    background: var(--neutral-color3) 0% 0% no-repeat padding-box !important;
}

.navbar-header-profile-section .wrapper-navbar-header-profile-section>svg:last-child {
    transform: rotate(0deg);
    transition: all 0.5s;
}

.navbar-header-profile-section.navbar-header-profile-section-active .wrapper-navbar-header-profile-section>svg:last-child {
    transform: rotate(180deg);
    transition: all 0.5s;
}

.navbar-header-profile-section-active .navbar-profile-img {
    border: 1px solid var(--neutral-color1);
    background-color: var(--bg-white);
}

.navbar-header-profile-section .navbar-header-profile-details-section {
    position: absolute;
    top: 0;
    transform: translateY(0);
    transition: all 0.2s;
    visibility: hidden;
    opacity: 0;
    top: calc(var(--header-height) - var(--border-top) - 10px);
    cursor: default;
    width: 280px;
    min-height: 100%;
    background: var(--neutral-color1) 0% 0% no-repeat padding-box;
    box-shadow: 0px 5px 10px var(--border-shadow-color3);
    padding: 20px;
    transition: all 0.2s;
    right: 0;
}

.navbar-header-profile-section-active .navbar-header-profile-details-section {
    position: absolute;
    visibility: visible;
    top: calc(var(--header-height) - var(--border-top));
    transform: translateY(0);
    cursor: default;
    width: 280px;
    min-height: 100%;
    background: var(--neutral-color1) 0% 0% no-repeat padding-box;
    box-shadow: 0px 5px 10px var(--border-shadow-color3);
    padding: 20px;
    transition: all 0.5s;
    right: 0;
    border-top: 1px solid;
    opacity: 1;
}

.navbar-header-profile-section-active .navbar-header-profile-details-section .wrapper-header-profile-details-section {
    display: grid;
    grid-template-columns: 1fr;
    grid-row-gap: 6px;
}

.navbar-header-profile-section-active .navbar-header-profile-details-section .wrapper-header-profile-details-section .profile-details-item-group-section:first-child {
    display: grid;
    grid-template-columns: 1.7fr 1fr;
}

.navbar-header-profile-section-active .navbar-header-profile-details-section .wrapper-header-profile-details-section .profile-details-item-group-section:first-child .profile-details-item:first-child {
    font: normal normal bold 20px/24px Lato;
    letter-spacing: 0.2px;
    color: var(--neutral-color7);
}

.navbar-header-profile-section-active .navbar-header-profile-details-section .wrapper-header-profile-details-section .profile-details-item-group-section:first-child .profile-details-item:last-child {
    display: grid;
    justify-items: flex-end;
}

.navbar-header-profile-section-active .navbar-header-profile-details-section .wrapper-header-profile-details-section .profile-details-item-group-section:first-child .profile-details-item:last-child .logout-btn-section {
    background: var(--call-to-action1) 0% 0% no-repeat padding-box;
    border-radius: 20px;
    align-items: center;
    width: 77px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    font: normal normal bold 14px/17px Lato;
    letter-spacing: 0.14px;
    color: var(--neutral-color1);
    cursor: pointer;
    transition: all 0.5s;
}

.navbar-header-profile-section-active .navbar-header-profile-details-section .wrapper-header-profile-details-section .profile-details-item-group-section:first-child .profile-details-item:last-child .logout-btn-section:hover {
    background-color: var(--call-to-action2);
    transition: all 0.5s;
}

.navbar-header-profile-section-active .navbar-header-profile-details-section .wrapper-header-profile-details-section .profile-details-item-group-section:last-child {
    display: grid;
    grid-template-columns: 1fr;
    grid-column-gap: 10px;
}


.navbar-header-profile-section .navbar-header-profile-details-section .wrapper-header-profile-details-section .profile-details-item-group-section:last-child .profile-details-item:not(:last-child),
.navbar-header-profile-section-active .navbar-header-profile-details-section .wrapper-header-profile-details-section .profile-details-item-group-section:last-child .profile-details-item:not(:last-child) {
    border-bottom: 1px solid var(--neutral-color4);
    padding-top: 7px;
    padding-bottom: 7px;
}

.navbar-header-profile-section .navbar-header-profile-details-section .wrapper-header-profile-details-section .profile-details-item-group-section:last-child .profile-details-item:last-child,
.navbar-header-profile-section-active .navbar-header-profile-details-section .wrapper-header-profile-details-section .profile-details-item-group-section:last-child .profile-details-item:last-child {
    padding-top: 7px;
}

.navbar-header-profile-section .navbar-header-profile-details-section .wrapper-header-profile-details-section .profile-details-item-group-section:last-child .profile-details-item,
.navbar-header-profile-section-active .navbar-header-profile-details-section .wrapper-header-profile-details-section .profile-details-item-group-section:last-child .profile-details-item {
    font: normal normal bold 12px/15px Lato;
    letter-spacing: 0.12px;
}

.navbar-header-profile-section-active .navbar-header-profile-details-section .wrapper-header-profile-details-section .profile-details-item-group-section:last-child .profile-details-item .profile-details-item-title {
    color: var(--neutral-color7);
}

.navbar-header-profile-section-active .navbar-header-profile-details-section .wrapper-header-profile-details-section .profile-details-item-group-section:last-child .profile-details-item-value {
    color: var(--neutral-color5);
    font-weight: normal;
}


.admin-super-navbar-header-content-section .navbar-header-nav-menu-section .navbar-header-menu-item:last-child .switch-user-btn-section,
.admin-super-navbar-header-content-section .navbar-header-nav-menu-section .navbar-header-menu-item:last-child::after {
    background: var(--indicators-red) 0% 0% no-repeat padding-box;
}

.admin-super-navbar-header-content-section .navbar-header-profile-section {
    background: var(--bg-profile) 0% 0% no-repeat padding-box;
}

/* --------- Personal Details Modal -------- */
#personalDetailsModal .modal-header-title-section svg {
    margin: 0;
    margin-right: 10px;
}

#personalDetailsModal .modal-body {
    padding-top: 0;
    margin-top: 0;
}

#personalDetailsModal .modal-body .wrapper-modal-body {
    row-gap: 0;
}

#personalDetailsModal .modal-body-item-section:first-child {
    height: 137px;
    display: grid;
    align-items: center;
    justify-items: center;
    background-color: var(--accordion-btn-bg-color1);
    border-bottom: 1px solid var(--neutral-color4);
}

#personalDetailsModal .modal-body-item-section .navbar-profile-img {
    width: 85px;
    height: 86px;
    border: 1px solid var(--neutral-color4);
}

#personalDetailsModal .modal-body-item-section .navbar-profile-img svg {
    height: 50%;
    width: 50%;
}

#personalDetailsModal .modal-body-item-section:nth-child(2) {
    display: grid;
    grid-template-columns: 1fr;
    justify-items: flex-start;
    width: 100%;
}

#personalDetailsModal .modal-body-item-section:nth-child(2) .profile-details-item {
    display: grid;
    width: 100%;
    justify-items: flex-start;
    padding: 10px 0 10px 20px;
    border-bottom: 1px solid var(--neutral-color4);
}

#personalDetailsModal .modal-body-item-section:nth-child(2) .profile-details-item:last-child {
    border-bottom: none;
}

#personalDetailsModal .modal-body-item-section:nth-child(2) .profile-details-item .profile-details-item-title {
    font-weight: bold;
}

/* --------- Logout Modal --------  */
.logout-modal .modal-dialog {
    max-width: 40%;
    margin-top: 8%;
}

.logout-modal .modal-dialog .modal-content .modal-footer {
    padding: 2rem 1.5rem
}

.logout-modal .modal-dialog .modal-content {
    min-height: 30vh;
    padding: 0 51px;
}

.logout-modal .modal-dialog .wrapper-modal-header {
    width: 100%;
    padding: 60px 0;
    padding-bottom: 12px;
}

.logout-modal .modal-header-title-section {
    display: flex;
    width: 100%;
    align-items: center;
    flex-direction: column;
    row-gap: 10px;
}

.logout-modal .modal-header-title-section svg {
    width: 39px;
    height: 42px;
}

.logout-modal .modal-header-title-section div:nth-child(2) {
    font: normal normal bold 22px/27px Lato;
    letter-spacing: 0.22px;
}

.logout-modal .modal-header-title-section div:nth-child(3) {
    font: normal normal normal 18px/22px Lato;
    letter-spacing: 0.18px;
}

.logout-modal .modal-body .wrapper-modal-body {
    display: grid;
    align-items: center;
    text-align: center;
    font: normal normal normal 22px/27px Lato;
    letter-spacing: 0.22px;
}

/* --------- Mobile Design ----------- */
@media screen and (max-width:992px) {
    :root {
        --header-height: 4.063rem;
        --border-top: 0.25rem;
        --search-activity-btn-font: normal normal 12px/14px Lato;
        ;
        --search-activity-btn-letter-spacing: 0.16px;
    }

    .navbar-header-profile-section-active .navbar-header-profile-details-section {
        display: none;
    }

    .header-wraper-section {
        grid-template-columns: 1fr 2fr 1fr;
        padding: 0;
    }

    .header-wraper-section>.navbar-header-icon-section img {
        width: 65px;
        height: 33px;
    }

    /* --------- Admin User ----------- */
    .header-wraper-admin-section {
        grid-template-columns: 1fr 2fr 1fr;
    }

    .header-wraper-admin-section .admin-navbar-header-content-section {
        grid-template-columns: 1fr;
    }

    .header-wraper-admin-section .admin-navbar-header-content-section .navbar-header-nav-menu-section {
        grid-template-columns: 1fr;
    }

    /* --------- Active Super Admin User ----------- */
    .header-wrapper-admin-super-section {
        grid-template-columns: 1fr 2fr 1.6fr;
    }

    .header-wrapper-admin-super-section .admin-super-navbar-header-content-section .navbar-header-nav-menu-section {
        grid-template-columns: 1fr 1fr;
    }

    .header-wrapper-admin-super-section .admin-super-navbar-header-content-section .navbar-header-nav-menu-section .navbar-header-menu-item:last-child {
        display: grid;
    }

    .header-wraper-super-section .navbar-header-nav-menu-section .navbar-header-menu-item:last-child{
        display: flex;
    }

    .header-wraper-super-section {
        grid-template-columns: 1fr 2fr 1fr;
    }


    /* .header-wraper-admin-section .navbar-header-content-section .navbar-header-nav-menu-section,
    .header-wraper-super-section .navbar-header-content-section .navbar-header-nav-menu-section {
        grid-template-columns: 1fr;
    }

    .header-wraper-admin-section .navbar-header-content-section .super-admin-nav-items,
    .header-wrapper-admin-super-section .admin-super-navbar-header-content-section .navbar-header-nav-menu-section {
        grid-template-columns: 1fr 1fr;
    }
    .header-wraper-admin-section .admin-navbar-header-content-section .super-admin-nav-items{
        grid-template-columns: 1fr;
    } */
    /* .header-wrapper-admin-super-section .admin-super-navbar-header-content-section .navbar-header-nav-menu-section .navbar-header-menu-item:last-child{
        display: grid;
    } */

    .header-wraper-section>.navbar-mobile-menu-group {
        display: grid;
        padding-left: 21px;
        height: 100%;
        align-items: center;
    }

    .navbar-header-icon-section {
        text-align: center;
    }

    .navbar-header-icon-section>img {
        width: 65px;
        height: 33px;
    }



    .navbar-header-content-section .navbar-header-menu-item,
    .navbar-header-profile-section {
        display: none;
    }

    .navbar-header-content-section .navbar-header-menu-item:nth-child(5),
    .super-admin-nav-items .navbar-header-menu-item:last-child {
        display: grid;
    }

    .navbar-header-content-section {
        grid-template-columns: 1fr;
    }

    .wrapper-navbar-header-menu-item {
        border: none;
    }

    .wrapper-navbar-header-menu-item svg,
    .navbar-header-menu-notification {
        height: 23px;
        width: 23px;
        font: normal normal bold 11px/13px Lato;
        letter-spacing: 0px;
    }

    .switch-user-btn-section svg {
        height: 19px;
        width: 19px;
    }

    .switch-user-btn-section .switch-user-btn-text {
        font: normal normal bold 11px/13px Lato;
        letter-spacing: 0.11px;
    }

    .logout-modal .modal-dialog .modal-content {
        position: absolute;
        height: auto;
        bottom: 0;
    }

    /* --------- Installer ----------- */
    .wrapper-installer-header-nav-btn {
        position: relative;
        min-width: 100%;
        height: 100%;
        border-radius: 0;
        flex-direction: column;
        justify-content: space-around;
        right: 0;
    }

    .header-wraper-super-section .navbar-header-content-section .navbar-header-nav-menu-section {
        grid-template-columns: 1fr;
    }

    .super-admin-nav-items .navbar-header-menu-item:last-child.active-tab {
        background-color: var(--bg-while-blue);
    }
}`, "",{"version":3,"sources":["webpack://./src/Assets/CSS/Header.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;IAC5B,uBAAuB;IACvB,oBAAoB;IACpB,6DAA6D;IAC7D,4CAA4C;;AAEhD;;AAEA;IACI,6DAA6D;IAC7D,4CAA4C;IAC5C,4BAA4B;IAC5B,aAAa;IACb,yDAAyD;IACzD,mBAAmB;IACnB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,iDAAiD;IACjD,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA,aAAa;AACb;IACI,2CAA2C;AAC/C;;AAEA;IACI,uDAAuD;IACvD,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,oBAAoB;AACxB;;;AAGA;IACI,kBAAkB;IAClB,cAAc;IACd,iBAAiB;AACrB;;;AAGA;IACI,UAAU;IACV,kBAAkB;IAClB,8DAA8D;AAClE;;;;AAIA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,8DAA8D;IAC9D,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,4BAA4B;IAC5B,kBAAkB;IAClB,SAAS;IACT,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,8DAA8D;IAC9D,uCAAuC;IACvC,sBAAsB;IACtB,eAAe;IACf,4BAA4B;IAC5B,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,sCAAsC;IACtC,oBAAoB;AACxB;;AAEA;IACI,uCAAuC;IACvC,oBAAoB;AACxB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,4BAA4B;IAC5B,oBAAoB;AACxB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,uCAAuC;IACvC,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,8DAA8D;IAC9D,SAAS;AACb;;AAEA;IACI,4DAA4D;AAChE;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,4CAA4C;IAC5C,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,4DAA4D;AAChE;;AAEA;IACI,uCAAuC;IACvC,mBAAmB;IACnB,4BAA4B;IAC5B,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,uCAAuC;IACvC,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA,sDAAsD;AACtD;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,8DAA8D;IAC9D,mBAAmB;IACnB,eAAe;IACf,kBAAkB;;IAElB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,qCAAqC;IACrC,yDAAyD;IACzD,4BAA4B;IAC5B,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,oBAAoB;AACxB;;AAEA,yCAAyC;AACzC;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,6DAA6D;IAC7D,SAAS;AACb;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,wEAAwE;AAC5E;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,uCAAuC;IACvC,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,wBAAwB;IACxB,oBAAoB;IACpB,kBAAkB;IAClB,UAAU;IACV,0DAA0D;IAC1D,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,6DAA6D;IAC7D,oDAAoD;IACpD,aAAa;IACb,oBAAoB;IACpB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,mDAAmD;IACnD,wBAAwB;IACxB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,6DAA6D;IAC7D,oDAAoD;IACpD,aAAa;IACb,oBAAoB;IACpB,QAAQ;IACR,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,uCAAuC;IACvC,qBAAqB;IACrB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,8DAA8D;IAC9D,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uCAAuC;IACvC,sBAAsB;IACtB,4BAA4B;IAC5B,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,wCAAwC;IACxC,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,qBAAqB;AACzB;;;AAGA;;IAEI,8CAA8C;IAC9C,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,uCAAuC;IACvC,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;IAC5B,mBAAmB;AACvB;;;AAGA;;IAEI,6DAA6D;AACjE;;AAEA;IACI,yDAAyD;AAC7D;;AAEA,8CAA8C;AAC9C;IACI,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,gDAAgD;IAChD,8CAA8C;AAClD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uCAAuC;AAC3C;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,qCAAqC;AACrC;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,uCAAuC;IACvC,sBAAsB;AAC1B;;AAEA;IACI,yCAAyC;IACzC,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,yCAAyC;IACzC,sBAAsB;AAC1B;;AAEA,wCAAwC;AACxC;IACI;QACI,yBAAyB;QACzB,qBAAqB;QACrB,wDAAwD;;QAExD,4CAA4C;IAChD;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kCAAkC;QAClC,UAAU;IACd;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA,qCAAqC;IACrC;QACI,kCAAkC;IACtC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA,kDAAkD;IAClD;QACI,oCAAoC;IACxC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kCAAkC;IACtC;;;IAGA;;;;;;;;;;;OAWG;IACH;;OAEG;;IAEH;QACI,aAAa;QACb,kBAAkB;QAClB,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;;;IAIA;;QAEI,aAAa;IACjB;;IAEA;;QAEI,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,YAAY;IAChB;;IAEA;;QAEI,YAAY;QACZ,WAAW;QACX,uCAAuC;QACvC,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,uCAAuC;QACvC,sBAAsB;IAC1B;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,SAAS;IACb;;IAEA,oCAAoC;IACpC;QACI,kBAAkB;QAClB,eAAe;QACf,YAAY;QACZ,gBAAgB;QAChB,sBAAsB;QACtB,6BAA6B;QAC7B,QAAQ;IACZ;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,sCAAsC;IAC1C;AACJ","sourcesContent":[":root {\r\n    /* ----------------------- */\r\n    --header-height: 5.5rem;\r\n    --border-top: 0.5rem;\r\n    --search-activity-btn-font: normal normal bold 16px/19px Lato;\r\n    --search-activity-btn-letter-spacing: 0.16px;\r\n\r\n}\r\n\r\n.header-start-section {\r\n    background: var(--neutral-color1) 0% 0% no-repeat padding-box;\r\n    box-shadow: 0rem 0.188rem 0.375rem #00000029;\r\n    height: var(--header-height);\r\n    display: grid;\r\n    border-top: var(--border-top) solid var(--neutral-color7);\r\n    align-items: center;\r\n    z-index: 50;\r\n    opacity: 1;\r\n}\r\n\r\n.header-wraper-section {\r\n    display: grid;\r\n    height: 100%;\r\n    align-items: center;\r\n    grid-template-columns: 1fr 6fr;\r\n    width: 100%;\r\n    padding: 0 24px;\r\n    padding-right: 0;\r\n}\r\n\r\n.header-wraper-admin-section {\r\n    grid-template-columns: 1fr 4fr;\r\n}\r\n\r\n.header-wrapper-admin-super-section {\r\n    grid-template-columns: 1.5fr 6fr;\r\n}\r\n\r\n.header-wraper-admin-section .admin-navbar-header-content-section {\r\n    grid-template-columns: 6fr 2fr;\r\n}\r\n\r\n.header-wraper-section>.navbar-header-icon-section img {\r\n    cursor: pointer;\r\n    width: 106px;\r\n    height: 53px;\r\n}\r\n\r\n.header-wraper-section>.navbar-mobile-menu-group {\r\n    display: none;\r\n}\r\n\r\n.navbar-header-content-section {\r\n    height: 100%;\r\n    display: grid;\r\n    align-items: center;\r\n    grid-template-columns: 8fr 2fr;\r\n}\r\n\r\n.navbar-header-nav-menu-section {\r\n    display: flex;\r\n    /* grid-template-columns: repeat(4, 1fr) 0.5fr; */\r\n    height: 100%;\r\n    align-items: center;\r\n    justify-content: flex-end;\r\n    text-align: center;\r\n    /* column-gap: 10px; */\r\n}\r\n\r\n.navbar-header-nav-menu-section .navbar-header-menu-item .menu-item-text {\r\n    transition: all 0.5s;\r\n}\r\n\r\n.navbar-header-nav-menu-section .navbar-header-menu-item:hover .menu-item-text {\r\n    color: var(--call-to-action1);\r\n    transition: all 0.5s;\r\n}\r\n\r\n.navbar-header-content-section .navbar-header-nav-menu-section .navbar-header-menu-item:nth-child(5):hover {\r\n    background-color: var(--bg-while-blue);\r\n}\r\n\r\n/* point-to */\r\n.super-admin-nav-items {\r\n    grid-template-columns: repeat(3, 3fr) 1.2fr;\r\n}\r\n\r\n.admin-super-navbar-header-content-section .navbar-header-nav-menu-section {\r\n    /* grid-template-columns: repeat(4, 3fr) 1.2fr 1.2fr; */\r\n    column-gap: 0;\r\n}\r\n\r\n.admin-super-navbar-header-content-section .navbar-header-nav-menu-section .navbar-header-menu-item:last-child.active-tab {\r\n    padding: 0;\r\n}\r\n\r\n.navbar-header-nav-menu-section>.navbar-header-menu-item {\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    position: relative;\r\n    padding: 0 15px;\r\n}\r\n\r\n.header-wraper-super-section .navbar-header-nav-menu-section .navbar-header-menu-item:last-child{\r\n    padding: 0;\r\n}\r\n\r\n.navbar-header-menu-item>.menu-item-icon {\r\n    margin-right: 10px;\r\n}\r\n\r\n.admin-navbar-header-content-section .navbar-header-nav-menu-section .navbar-header-menu-item:nth-child(4) {\r\n    padding: 0;\r\n}\r\n\r\n.navbar-header-content-section .navbar-header-nav-menu-section .navbar-header-menu-item:nth-child(5) {\r\n    position: relative;\r\n    padding: 0;\r\n    padding-top: 15px;\r\n    padding-bottom: 15px;\r\n}\r\n\r\n\r\n.admin-navbar-header-content-section .navbar-header-nav-menu-section .navbar-header-menu-item:nth-child(5) {\r\n    position: relative;\r\n    padding-top: 0;\r\n    padding-bottom: 0;\r\n}\r\n\r\n\r\n.super-admin-nav-items .navbar-header-menu-item:last-child {\r\n    padding: 0;\r\n    position: relative;\r\n    background: var(--call-to-action1) 0% 0% no-repeat padding-box;\r\n}\r\n\r\n\r\n\r\n.wrapper-navbar-header-menu-item {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding-left: 25px;\r\n    padding-right: 25px;\r\n    border-left: 1px solid var(--neutral-color4);\r\n}\r\n\r\n.navbar-header-menu-notification {\r\n    min-width: 23px;\r\n    min-height: 23px;\r\n    background: var(--call-to-action1) 0% 0% no-repeat padding-box;\r\n    border-radius: 50%;\r\n    padding: 4px 4px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    color: var(--neutral-color1);\r\n    position: absolute;\r\n    top: 10px;\r\n    left: 55%;\r\n}\r\n\r\n.switch-user-btn-section {\r\n    height: 100%;\r\n    width: 100%;\r\n    display: grid;\r\n    align-items: center;\r\n    justify-items: center;\r\n    background: var(--call-to-action1) 0% 0% no-repeat padding-box;\r\n    font: normal normal bold 12px/15px Lato;\r\n    letter-spacing: 0.12px;\r\n    padding: 0 10px;\r\n    color: var(--neutral-color1);\r\n    transition: all 0.5s;\r\n}\r\n\r\n.switch-user-btn-section svg path {\r\n    fill: var(--neutral-color1);\r\n    transition: all 0.5s;\r\n}\r\n\r\n.activetab-switch-user-btn {\r\n    background-color: var(--bg-while-blue);\r\n    transition: all 0.5s;\r\n}\r\n\r\n.active-switch-user-btn {\r\n    background-color: var(--indicators-red);\r\n    transition: all 0.5s;\r\n}\r\n\r\n.switch-user-btn-icon {\r\n    height: 40%;\r\n}\r\n\r\n.activetab-switch-user-btn svg path {\r\n    fill: var(--call-to-action1);\r\n    transition: all 0.5s;\r\n}\r\n\r\n.activetab-switch-user-btn .switch-user-btn-text {\r\n    color: var(--call-to-action1);\r\n}\r\n\r\n.active-tab .menu-item-text {\r\n    font: normal normal bold 16px/19px Lato;\r\n    letter-spacing: 0.16px;\r\n    color: var(--call-to-action1);\r\n}\r\n\r\n.navbar-header-nav-menu-section .active-tab::after {\r\n    content: \"\";\r\n    height: 4px;\r\n    width: 100%;\r\n    position: absolute;\r\n    background: var(--call-to-action1) 0% 0% no-repeat padding-box;\r\n    bottom: 0;\r\n}\r\n\r\n.cart-active {\r\n    background: var(--bg-while-blue) 0% 0% no-repeat padding-box;\r\n}\r\n\r\n.cart-active .wrapper-navbar-header-menu-item {\r\n    border: 0;\r\n}\r\n\r\n.navbar-header-profile-section {\r\n    height: 100%;\r\n    width: 100%;\r\n    display: grid;\r\n    align-items: center;\r\n    padding: 15px 0;\r\n    cursor: pointer;\r\n}\r\n\r\n.wrapper-navbar-header-profile-section {\r\n    height: 100%;\r\n    width: 100%;\r\n    border-left: 1px solid var(--neutral-color4);\r\n    padding: 0 20px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n\r\n.wrapper-navbar-header-profile-section>.navbar-profile-img,\r\n.navbar-profile-content-section {\r\n    margin-right: 10px;\r\n}\r\n\r\n.navbar-profile-img {\r\n    width: 38px;\r\n    height: 38px;\r\n    border-radius: 50%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background: var(--bg-while-blue) 0% 0% no-repeat padding-box;\r\n}\r\n\r\n.navbar-profile-content-section>.profile-username {\r\n    font: normal normal bold 12px/15px Lato;\r\n    letter-spacing: 0px;\r\n    color: var(--neutral-color7);\r\n    width: 100px;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}\r\n\r\n.navbar-profile-content-section>.profile-id {\r\n    font: normal normal bold 14px/17px Lato;\r\n    letter-spacing: 0px;\r\n    color: var(--call-to-action1);\r\n}\r\n\r\n/* ------------------- Installer ------------------- */\r\n.navbar-header-search-btn-section {\r\n    position: relative;\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.wrapper-installer-header-nav-btn {\r\n    position: absolute;\r\n    right: 20px;\r\n    min-width: 170px;\r\n    height: 50px;\r\n    background: var(--call-to-action1) 0% 0% no-repeat padding-box;\r\n    border-radius: 26px;\r\n    padding: 0 12px;\r\n    text-align: center;\r\n\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    font: var(--search-activity-btn-font);\r\n    letter-spacing: var(--search-activity-btn-letter-spacing);\r\n    color: var(--neutral-color1);\r\n    cursor: pointer;\r\n    transition: all 0.5s;\r\n}\r\n\r\n.wrapper-installer-header-nav-btn>svg {\r\n    margin-right: 10px;\r\n}\r\n\r\n.wrapper-installer-header-nav-btn:hover {\r\n    background-color: var(--call-to-action2);\r\n    transition: all 0.5s;\r\n}\r\n\r\n/* ----------- Profile Section -------- */\r\n.navbar-header-profile-section {\r\n    position: relative;\r\n}\r\n\r\n.navbar-header-profile-section.navbar-header-profile-section-active::after {\r\n    content: \"\";\r\n    height: 4px;\r\n    width: 100%;\r\n    position: absolute;\r\n    background: var(--neutral-color7) 0% 0% no-repeat padding-box;\r\n    bottom: 0;\r\n}\r\n\r\n.navbar-header-profile-section {\r\n    background-color: var(--bg-white);\r\n}\r\n\r\n.navbar-header-profile-section.navbar-header-profile-section:hover {\r\n    background-color: var(--neutral-color3);\r\n}\r\n\r\n.navbar-header-profile-section.navbar-header-profile-section-active {\r\n    background: var(--neutral-color3) 0% 0% no-repeat padding-box !important;\r\n}\r\n\r\n.navbar-header-profile-section .wrapper-navbar-header-profile-section>svg:last-child {\r\n    transform: rotate(0deg);\r\n    transition: all 0.5s;\r\n}\r\n\r\n.navbar-header-profile-section.navbar-header-profile-section-active .wrapper-navbar-header-profile-section>svg:last-child {\r\n    transform: rotate(180deg);\r\n    transition: all 0.5s;\r\n}\r\n\r\n.navbar-header-profile-section-active .navbar-profile-img {\r\n    border: 1px solid var(--neutral-color1);\r\n    background-color: var(--bg-white);\r\n}\r\n\r\n.navbar-header-profile-section .navbar-header-profile-details-section {\r\n    position: absolute;\r\n    top: 0;\r\n    transform: translateY(0);\r\n    transition: all 0.2s;\r\n    visibility: hidden;\r\n    opacity: 0;\r\n    top: calc(var(--header-height) - var(--border-top) - 10px);\r\n    cursor: default;\r\n    width: 280px;\r\n    min-height: 100%;\r\n    background: var(--neutral-color1) 0% 0% no-repeat padding-box;\r\n    box-shadow: 0px 5px 10px var(--border-shadow-color3);\r\n    padding: 20px;\r\n    transition: all 0.2s;\r\n    right: 0;\r\n}\r\n\r\n.navbar-header-profile-section-active .navbar-header-profile-details-section {\r\n    position: absolute;\r\n    visibility: visible;\r\n    top: calc(var(--header-height) - var(--border-top));\r\n    transform: translateY(0);\r\n    cursor: default;\r\n    width: 280px;\r\n    min-height: 100%;\r\n    background: var(--neutral-color1) 0% 0% no-repeat padding-box;\r\n    box-shadow: 0px 5px 10px var(--border-shadow-color3);\r\n    padding: 20px;\r\n    transition: all 0.5s;\r\n    right: 0;\r\n    border-top: 1px solid;\r\n    opacity: 1;\r\n}\r\n\r\n.navbar-header-profile-section-active .navbar-header-profile-details-section .wrapper-header-profile-details-section {\r\n    display: grid;\r\n    grid-template-columns: 1fr;\r\n    grid-row-gap: 6px;\r\n}\r\n\r\n.navbar-header-profile-section-active .navbar-header-profile-details-section .wrapper-header-profile-details-section .profile-details-item-group-section:first-child {\r\n    display: grid;\r\n    grid-template-columns: 1.7fr 1fr;\r\n}\r\n\r\n.navbar-header-profile-section-active .navbar-header-profile-details-section .wrapper-header-profile-details-section .profile-details-item-group-section:first-child .profile-details-item:first-child {\r\n    font: normal normal bold 20px/24px Lato;\r\n    letter-spacing: 0.2px;\r\n    color: var(--neutral-color7);\r\n}\r\n\r\n.navbar-header-profile-section-active .navbar-header-profile-details-section .wrapper-header-profile-details-section .profile-details-item-group-section:first-child .profile-details-item:last-child {\r\n    display: grid;\r\n    justify-items: flex-end;\r\n}\r\n\r\n.navbar-header-profile-section-active .navbar-header-profile-details-section .wrapper-header-profile-details-section .profile-details-item-group-section:first-child .profile-details-item:last-child .logout-btn-section {\r\n    background: var(--call-to-action1) 0% 0% no-repeat padding-box;\r\n    border-radius: 20px;\r\n    align-items: center;\r\n    width: 77px;\r\n    height: 32px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font: normal normal bold 14px/17px Lato;\r\n    letter-spacing: 0.14px;\r\n    color: var(--neutral-color1);\r\n    cursor: pointer;\r\n    transition: all 0.5s;\r\n}\r\n\r\n.navbar-header-profile-section-active .navbar-header-profile-details-section .wrapper-header-profile-details-section .profile-details-item-group-section:first-child .profile-details-item:last-child .logout-btn-section:hover {\r\n    background-color: var(--call-to-action2);\r\n    transition: all 0.5s;\r\n}\r\n\r\n.navbar-header-profile-section-active .navbar-header-profile-details-section .wrapper-header-profile-details-section .profile-details-item-group-section:last-child {\r\n    display: grid;\r\n    grid-template-columns: 1fr;\r\n    grid-column-gap: 10px;\r\n}\r\n\r\n\r\n.navbar-header-profile-section .navbar-header-profile-details-section .wrapper-header-profile-details-section .profile-details-item-group-section:last-child .profile-details-item:not(:last-child),\r\n.navbar-header-profile-section-active .navbar-header-profile-details-section .wrapper-header-profile-details-section .profile-details-item-group-section:last-child .profile-details-item:not(:last-child) {\r\n    border-bottom: 1px solid var(--neutral-color4);\r\n    padding-top: 7px;\r\n    padding-bottom: 7px;\r\n}\r\n\r\n.navbar-header-profile-section .navbar-header-profile-details-section .wrapper-header-profile-details-section .profile-details-item-group-section:last-child .profile-details-item:last-child,\r\n.navbar-header-profile-section-active .navbar-header-profile-details-section .wrapper-header-profile-details-section .profile-details-item-group-section:last-child .profile-details-item:last-child {\r\n    padding-top: 7px;\r\n}\r\n\r\n.navbar-header-profile-section .navbar-header-profile-details-section .wrapper-header-profile-details-section .profile-details-item-group-section:last-child .profile-details-item,\r\n.navbar-header-profile-section-active .navbar-header-profile-details-section .wrapper-header-profile-details-section .profile-details-item-group-section:last-child .profile-details-item {\r\n    font: normal normal bold 12px/15px Lato;\r\n    letter-spacing: 0.12px;\r\n}\r\n\r\n.navbar-header-profile-section-active .navbar-header-profile-details-section .wrapper-header-profile-details-section .profile-details-item-group-section:last-child .profile-details-item .profile-details-item-title {\r\n    color: var(--neutral-color7);\r\n}\r\n\r\n.navbar-header-profile-section-active .navbar-header-profile-details-section .wrapper-header-profile-details-section .profile-details-item-group-section:last-child .profile-details-item-value {\r\n    color: var(--neutral-color5);\r\n    font-weight: normal;\r\n}\r\n\r\n\r\n.admin-super-navbar-header-content-section .navbar-header-nav-menu-section .navbar-header-menu-item:last-child .switch-user-btn-section,\r\n.admin-super-navbar-header-content-section .navbar-header-nav-menu-section .navbar-header-menu-item:last-child::after {\r\n    background: var(--indicators-red) 0% 0% no-repeat padding-box;\r\n}\r\n\r\n.admin-super-navbar-header-content-section .navbar-header-profile-section {\r\n    background: var(--bg-profile) 0% 0% no-repeat padding-box;\r\n}\r\n\r\n/* --------- Personal Details Modal -------- */\r\n#personalDetailsModal .modal-header-title-section svg {\r\n    margin: 0;\r\n    margin-right: 10px;\r\n}\r\n\r\n#personalDetailsModal .modal-body {\r\n    padding-top: 0;\r\n    margin-top: 0;\r\n}\r\n\r\n#personalDetailsModal .modal-body .wrapper-modal-body {\r\n    row-gap: 0;\r\n}\r\n\r\n#personalDetailsModal .modal-body-item-section:first-child {\r\n    height: 137px;\r\n    display: grid;\r\n    align-items: center;\r\n    justify-items: center;\r\n    background-color: var(--accordion-btn-bg-color1);\r\n    border-bottom: 1px solid var(--neutral-color4);\r\n}\r\n\r\n#personalDetailsModal .modal-body-item-section .navbar-profile-img {\r\n    width: 85px;\r\n    height: 86px;\r\n    border: 1px solid var(--neutral-color4);\r\n}\r\n\r\n#personalDetailsModal .modal-body-item-section .navbar-profile-img svg {\r\n    height: 50%;\r\n    width: 50%;\r\n}\r\n\r\n#personalDetailsModal .modal-body-item-section:nth-child(2) {\r\n    display: grid;\r\n    grid-template-columns: 1fr;\r\n    justify-items: flex-start;\r\n    width: 100%;\r\n}\r\n\r\n#personalDetailsModal .modal-body-item-section:nth-child(2) .profile-details-item {\r\n    display: grid;\r\n    width: 100%;\r\n    justify-items: flex-start;\r\n    padding: 10px 0 10px 20px;\r\n    border-bottom: 1px solid var(--neutral-color4);\r\n}\r\n\r\n#personalDetailsModal .modal-body-item-section:nth-child(2) .profile-details-item:last-child {\r\n    border-bottom: none;\r\n}\r\n\r\n#personalDetailsModal .modal-body-item-section:nth-child(2) .profile-details-item .profile-details-item-title {\r\n    font-weight: bold;\r\n}\r\n\r\n/* --------- Logout Modal --------  */\r\n.logout-modal .modal-dialog {\r\n    max-width: 40%;\r\n    margin-top: 8%;\r\n}\r\n\r\n.logout-modal .modal-dialog .modal-content .modal-footer {\r\n    padding: 2rem 1.5rem\r\n}\r\n\r\n.logout-modal .modal-dialog .modal-content {\r\n    min-height: 30vh;\r\n    padding: 0 51px;\r\n}\r\n\r\n.logout-modal .modal-dialog .wrapper-modal-header {\r\n    width: 100%;\r\n    padding: 60px 0;\r\n    padding-bottom: 12px;\r\n}\r\n\r\n.logout-modal .modal-header-title-section {\r\n    display: flex;\r\n    width: 100%;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    row-gap: 10px;\r\n}\r\n\r\n.logout-modal .modal-header-title-section svg {\r\n    width: 39px;\r\n    height: 42px;\r\n}\r\n\r\n.logout-modal .modal-header-title-section div:nth-child(2) {\r\n    font: normal normal bold 22px/27px Lato;\r\n    letter-spacing: 0.22px;\r\n}\r\n\r\n.logout-modal .modal-header-title-section div:nth-child(3) {\r\n    font: normal normal normal 18px/22px Lato;\r\n    letter-spacing: 0.18px;\r\n}\r\n\r\n.logout-modal .modal-body .wrapper-modal-body {\r\n    display: grid;\r\n    align-items: center;\r\n    text-align: center;\r\n    font: normal normal normal 22px/27px Lato;\r\n    letter-spacing: 0.22px;\r\n}\r\n\r\n/* --------- Mobile Design ----------- */\r\n@media screen and (max-width:992px) {\r\n    :root {\r\n        --header-height: 4.063rem;\r\n        --border-top: 0.25rem;\r\n        --search-activity-btn-font: normal normal 12px/14px Lato;\r\n        ;\r\n        --search-activity-btn-letter-spacing: 0.16px;\r\n    }\r\n\r\n    .navbar-header-profile-section-active .navbar-header-profile-details-section {\r\n        display: none;\r\n    }\r\n\r\n    .header-wraper-section {\r\n        grid-template-columns: 1fr 2fr 1fr;\r\n        padding: 0;\r\n    }\r\n\r\n    .header-wraper-section>.navbar-header-icon-section img {\r\n        width: 65px;\r\n        height: 33px;\r\n    }\r\n\r\n    /* --------- Admin User ----------- */\r\n    .header-wraper-admin-section {\r\n        grid-template-columns: 1fr 2fr 1fr;\r\n    }\r\n\r\n    .header-wraper-admin-section .admin-navbar-header-content-section {\r\n        grid-template-columns: 1fr;\r\n    }\r\n\r\n    .header-wraper-admin-section .admin-navbar-header-content-section .navbar-header-nav-menu-section {\r\n        grid-template-columns: 1fr;\r\n    }\r\n\r\n    /* --------- Active Super Admin User ----------- */\r\n    .header-wrapper-admin-super-section {\r\n        grid-template-columns: 1fr 2fr 1.6fr;\r\n    }\r\n\r\n    .header-wrapper-admin-super-section .admin-super-navbar-header-content-section .navbar-header-nav-menu-section {\r\n        grid-template-columns: 1fr 1fr;\r\n    }\r\n\r\n    .header-wrapper-admin-super-section .admin-super-navbar-header-content-section .navbar-header-nav-menu-section .navbar-header-menu-item:last-child {\r\n        display: grid;\r\n    }\r\n\r\n    .header-wraper-super-section .navbar-header-nav-menu-section .navbar-header-menu-item:last-child{\r\n        display: flex;\r\n    }\r\n\r\n    .header-wraper-super-section {\r\n        grid-template-columns: 1fr 2fr 1fr;\r\n    }\r\n\r\n\r\n    /* .header-wraper-admin-section .navbar-header-content-section .navbar-header-nav-menu-section,\r\n    .header-wraper-super-section .navbar-header-content-section .navbar-header-nav-menu-section {\r\n        grid-template-columns: 1fr;\r\n    }\r\n\r\n    .header-wraper-admin-section .navbar-header-content-section .super-admin-nav-items,\r\n    .header-wrapper-admin-super-section .admin-super-navbar-header-content-section .navbar-header-nav-menu-section {\r\n        grid-template-columns: 1fr 1fr;\r\n    }\r\n    .header-wraper-admin-section .admin-navbar-header-content-section .super-admin-nav-items{\r\n        grid-template-columns: 1fr;\r\n    } */\r\n    /* .header-wrapper-admin-super-section .admin-super-navbar-header-content-section .navbar-header-nav-menu-section .navbar-header-menu-item:last-child{\r\n        display: grid;\r\n    } */\r\n\r\n    .header-wraper-section>.navbar-mobile-menu-group {\r\n        display: grid;\r\n        padding-left: 21px;\r\n        height: 100%;\r\n        align-items: center;\r\n    }\r\n\r\n    .navbar-header-icon-section {\r\n        text-align: center;\r\n    }\r\n\r\n    .navbar-header-icon-section>img {\r\n        width: 65px;\r\n        height: 33px;\r\n    }\r\n\r\n\r\n\r\n    .navbar-header-content-section .navbar-header-menu-item,\r\n    .navbar-header-profile-section {\r\n        display: none;\r\n    }\r\n\r\n    .navbar-header-content-section .navbar-header-menu-item:nth-child(5),\r\n    .super-admin-nav-items .navbar-header-menu-item:last-child {\r\n        display: grid;\r\n    }\r\n\r\n    .navbar-header-content-section {\r\n        grid-template-columns: 1fr;\r\n    }\r\n\r\n    .wrapper-navbar-header-menu-item {\r\n        border: none;\r\n    }\r\n\r\n    .wrapper-navbar-header-menu-item svg,\r\n    .navbar-header-menu-notification {\r\n        height: 23px;\r\n        width: 23px;\r\n        font: normal normal bold 11px/13px Lato;\r\n        letter-spacing: 0px;\r\n    }\r\n\r\n    .switch-user-btn-section svg {\r\n        height: 19px;\r\n        width: 19px;\r\n    }\r\n\r\n    .switch-user-btn-section .switch-user-btn-text {\r\n        font: normal normal bold 11px/13px Lato;\r\n        letter-spacing: 0.11px;\r\n    }\r\n\r\n    .logout-modal .modal-dialog .modal-content {\r\n        position: absolute;\r\n        height: auto;\r\n        bottom: 0;\r\n    }\r\n\r\n    /* --------- Installer ----------- */\r\n    .wrapper-installer-header-nav-btn {\r\n        position: relative;\r\n        min-width: 100%;\r\n        height: 100%;\r\n        border-radius: 0;\r\n        flex-direction: column;\r\n        justify-content: space-around;\r\n        right: 0;\r\n    }\r\n\r\n    .header-wraper-super-section .navbar-header-content-section .navbar-header-nav-menu-section {\r\n        grid-template-columns: 1fr;\r\n    }\r\n\r\n    .super-admin-nav-items .navbar-header-menu-item:last-child.active-tab {\r\n        background-color: var(--bg-while-blue);\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
